import { getRoot, types } from 'mobx-state-tree'
import { RootModel } from '@shared/data-access'

export const MODEL_NAME = 'TestResult'

export const Model = RootModel.named(MODEL_NAME)
  .props({
    testResults: types.maybeNull(types.string),
  })
  .views((self) => ({
    get parsed() {
      return JSON.parse(self.testResults)
    },
  }))
  .volatile((self) => ({
    _store: getRoot(self)[`${MODEL_NAME}Store`],
  }))

export default Model
